module.exports = __webpack_public_path__ + "img/walk.9326df94.png";